import React from 'react';
import PublicLayout from './PublicLayout';
import PageHero from './PageHero';
import InfoCard from './InfoCard';
import CTASection from './CTASection';
import { usePageMeta } from '../../publicSite/usePageMeta';

export default function PublicPage({ meta, hero, sections = [], cta }) {
  usePageMeta(meta?.title, meta?.description);

  return (
    <PublicLayout>
      <PageHero
        eyebrow={hero.eyebrow}
        title={hero.title}
        subtitle={hero.subtitle}
        actions={hero.actions}
        image={hero.image}
        imageAlt={hero.imageAlt}
      />
      {sections.map(section => (
        <section key={section.title} className="ps-section">
          <div className="ps-section-inner">
            <h2 className="ps-section-title">{section.title}</h2>
            {section.subtitle && (
              <p style={{ color: 'var(--gray-600)', marginBottom: '16px' }}>{section.subtitle}</p>
            )}
            {section.cards && (
              <div className="ps-card-grid">
                {section.cards.map(card => (
                  <InfoCard key={card.title} title={card.title} description={card.description}>
                    {card.body}
                  </InfoCard>
                ))}
              </div>
            )}
            {section.content && section.content}
          </div>
        </section>
      ))}
      {cta && (
        <CTASection title={cta.title} subtitle={cta.subtitle} actions={cta.actions} />
      )}
    </PublicLayout>
  );
}
